export enum RadioActionTypes {

    Radiobutton_GET_LIST = '@@radio/Radiobutton_GET_LIST',
    Radiobutton_GET_LIST_LOAD= '@@radio/Radiobutton_GET_LIST_LOAD',      
    Radiobutton_GET_LIST_SUCCESS = '@@radio/Radiobutton_GET_LIST_SUCCESS',    
}
